module.exports = __webpack_public_path__ + "static/media/omar_garcia_flores.4b41c5e2.png";